// Apolo IDE — Hermes Team Mode: o agente-LÍDER auto-provisionado (D3).
//
// hermes_runs.agent_id é NOT NULL — a equipe precisa de um agent dono. Em vez
// de migration/nullable, o modo equipe usa UM agent por conta (role
// 'code-team'), criado on-demand e reutilizado pra sempre: ele é o dono da
// memória compartilhada (hermes_agent_memory) e o pai de toda árvore de runs
// da equipe — que de bônus aparece no RunBoard do Hermes de graça.
//
// O cwd do líder é ALINHADO ao root da sessão antes de cada team run, porque
// startRun snapshota agent.cwd como run.root (e sem root o executor recusa).
// Corrida entre duas sessões com roots diferentes é aceitável (single-user,
// rara) — o PATCH perdedor só muda o root do PRÓXIMO run, nunca de um run vivo.

import { TEAM_LIMITS } from '../domain/teamPlan.js';

export const TEAM_AGENT_ROLE = 'code-team';
export const TEAM_AGENT_NAME = 'Equipe do Code';

export function makeEnsureTeamAgent({ api } = {}) {
  /** ensureTeamAgent({ root }) → agent record (find-or-create, idempotente). */
  return async function ensureTeamAgent({ root } = {}) {
    const agents = await api.listAgents();
    let agent = (agents || []).find(
      (a) =>
        a?.role === TEAM_AGENT_ROLE &&
        !a?.deletedAt &&
        (a?.enabled === undefined || a?.enabled === true || a?.enabled === 1),
    );

    if (!agent) {
      agent = await api.createAgent({
        name: TEAM_AGENT_NAME,
        role: TEAM_AGENT_ROLE,
        cwd: root || null,
        fanoutCap: TEAM_LIMITS.capMax,
      });
      return agent;
    }

    if (root && agent.cwd !== root) {
      try {
        agent = await api.updateAgent(agent.id, { cwd: root });
      } catch {
        // Corrida/validação: segue com o registro em mãos — o caller ainda
        // precisa de um cwd correto pro PRÓXIMO startRun, então reflete local.
        agent = { ...agent, cwd: root };
      }
    }
    return agent;
  };
}
